import { KeyIndexImpl } from '../instructions';
import { ContextTransformFieldValues } from './autogen.context';
/**
 * @public
 */
export var ListPatternPositionIndex = new KeyIndexImpl(['start', 'middle', 'end', 'two']);
/**
 * @public
 */
export var ContextTransformFieldIndex = new KeyIndexImpl(ContextTransformFieldValues);
//# sourceMappingURL=general.js.map